import { MoreHorizontal, UserRound, Pencil, KeyRound, Archive, RotateCcw, GitMerge } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

export function ClientActionsMenu({ client, onView, onEdit, onReset, onArchive, onRestore, onMerge }) {
  const archived = client.status === "archived";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid={`client-actions-${client.id}`} variant="ghost" size="sm" className="h-8 w-8 p-0 rounded-lg"><MoreHorizontal className="h-4 w-4" strokeWidth={1.75} /></Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[195px] rounded-xl shadow-[0_12px_32px_rgba(15,23,42,0.12)]">
        <DropdownMenuItem data-testid={`client-view-profile-${client.id}`} onClick={onView} className="gap-2 text-sm"><UserRound size={14} strokeWidth={1.75} /> View profile</DropdownMenuItem>
        <DropdownMenuItem data-testid={`client-edit-${client.id}`} onClick={onEdit} className="gap-2 text-sm"><Pencil size={14} strokeWidth={1.75} /> Edit client</DropdownMenuItem>
        <DropdownMenuItem data-testid={`client-reset-${client.id}`} onClick={onReset} className="gap-2 text-sm"><KeyRound size={14} strokeWidth={1.75} /> Reset password</DropdownMenuItem>
        <DropdownMenuItem data-testid={`client-merge-${client.id}`} onClick={onMerge} className="gap-2 text-sm text-indigo-700"><GitMerge size={14} strokeWidth={1.75} /> Merge into…</DropdownMenuItem>
        <DropdownMenuSeparator />
        {archived ? (
          <DropdownMenuItem data-testid={`client-restore-${client.id}`} onClick={onRestore} className="gap-2 text-sm text-emerald-700"><RotateCcw size={14} strokeWidth={1.75} /> Restore client</DropdownMenuItem>
        ) : (
          <DropdownMenuItem data-testid={`client-archive-${client.id}`} onClick={onArchive} className="gap-2 text-sm text-amber-700"><Archive size={14} strokeWidth={1.75} /> Archive client</DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
